/**
 * CSS globale injectée une fois au montage de App.tsx.
 *
 * IMPORTANT : toute règle CSS ici DOIT être bornée par @media (max-width: ...).
 * Aucune règle ne doit affecter le rendu desktop (>= 1024px) — c'est la
 * contrainte "zéro régression desktop" du spec.
 *
 * Réservé aux règles qui ne se font pas proprement en JS :
 *   - body overflow lock pendant que le drawer est ouvert
 *   - reset de la sélection de texte sur les éléments tappés sur mobile
 *   - WebkitTapHighlightColor pour neutraliser le flash bleu Android
 */

export const RESPONSIVE_CSS = `
@media (max-width: 1023px) {
  body.servup-drawer-open {
    overflow: hidden;
    touch-action: none;
  }
}

@media (max-width: 767px) {
  /* Tap highlight bleu désactivé sur mobile */
  button, [role="button"], a {
    -webkit-tap-highlight-color: transparent;
  }

  /* Empêche le scroll horizontal sur le body sur phone */
  body {
    overflow-x: hidden;
  }
}
`.trim();
